export const mixinScanner = {
  data() {
    return {
      isScanProcess: false,
      scanBuffer: '',
      prefixScan: 'PageUp',
      prefixScanCode: 2,
      suffixScan: 'PageDown',
      suffixScanCode: 3,
    };
  },

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },

  methods: {
    handleKeyDown(event) {
      // console.log('MixinScanner handleKeyDown', event)
      if (this.storeConfirmStore.dialog === true) {
        // console.log('MixinScanner handleKeyDown return dialog is active', event)
        return
      }
      if (event.keyCode === this.prefixScanCode || event.key === this.prefixScan) {
        // console.log('handleKeyDown prefixScan', event)
        this.isScanProcess = true
        this.scanBuffer = ''
        event.preventDefault()
        event.stopPropagation()
        return
      }
      if (event.keyCode === this.suffixScanCode || event.key === this.suffixScan) {
        // console.log('handleKeyDown suffixScan', event)
        if (this.scanBuffer === 'test-mpn')
          this.scanBuffer = '1N4747A-TR'
        if (this.scanBuffer === 'test-pn')
          this.scanBuffer = 'test_new_pn_1.2'
        this.isScanProcess = false
        if (!!this.finishScan)
          this.finishScan(this.scanBuffer)
        event.preventDefault()
        event.stopPropagation()
      }
      if (this.isScanProcess) {
        if (event.key.length === 1) {
          // console.log('MixinScaner', event)
          this.scanBuffer += event.key
        }
        event.preventDefault()
        event.stopPropagation()
        // console.log('handleKeyDown add to scanBuffer', event, this.scanBuffer)
      }
    },
    findParentComponent(element) {
      let parent = element;
      while (parent) {
        if (parent.__vue__) {
          return parent.__vue__;
        }
        parent = parent.parentNode;
      }
      return null;
    },
    findParentComponentEnter(element) {
      let parent = element;
      while (parent) {
        // console.log('findParentComponentEnter', parent)
        if (parent.__vue__)
          break
        parent = parent.parentNode;
      }
      parent = parent.__vue__
      while (parent) {
        // console.log('findParentComponentEnter Vue', parent)
        if(!!parent.$options.propsData.enterInput)
          return parent
        parent = parent.$parent
      }
      return null;
    }
  }
}